import emailjs from '@emailjs/browser';
import { createExcelBlob, formatTestDataForEmail } from './excelService';

// EmailJS configuration
const EMAILJS_SERVICE_ID = 'service_1tgje7h'; // Yahoo service
const EMAILJS_TEMPLATE_ID = 'template_5epu87j'; // You'll need to create this template
const EMAILJS_PUBLIC_KEY = '8fOyIRPTRk0l3qwc8'; // You need to get this from EmailJS dashboard

// Initialize EmailJS with your public key
emailjs.init(EMAILJS_PUBLIC_KEY);

// Функция для конвертации Blob в Base64
const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const base64 = reader.result.split(',')[1]; // Убираем префикс data:application/...
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const sendTestResultsEmail = async (testResult, testType) => {
  try {
    // Excel файл временно отключен
    // Для теста по природным интеллектам создаем Excel файл
    let excelAttachment = null;
    // if (testType === 'natural_intelligence') {
    //   const excelResult = createExcelBlob(testResult);
    //   if (excelResult.success) {
    //     excelAttachment = {
    //       blob: excelResult.blob,
    //       fileName: excelResult.fileName
    //     };
    //   }
    // }
    
    // Форматируем данные для email
    const formattedAnswers = testType === 'natural_intelligence' 
      ? formatTestDataForEmail(testResult)
      : formatRawAnswersForEmail(testResult.answers, testType);
    
    // Prepare email data for template
    const emailData = {
      to_name: 'Anna Vladimirovna',
      to_email: 'developskillsnow@yandex.ru', // Ваша почта
      test_type: getTestTitle(testType),
      participant_name: testResult.userInfo.full_name,
      participant_email: testResult.userInfo.email,
      participant_phone: testResult.userInfo.phone,
      test_date: new Date().toLocaleDateString('ru-RU'),
      test_time: new Date().toLocaleTimeString('ru-RU'),
      summary: testResult.summary || testResult.dominantType || 'Результаты теста',
      detailed_results: formatDetailedResultsForEmail(testResult, testType),
      excel_table: createExcelLikeTable(testResult, testType), // HTML таблица как Excel
      has_excel_attachment: 'false', // Excel временно отключен
      excel_filename: ''
      // has_excel_attachment: excelAttachment ? 'true' : 'false',
      // excel_filename: excelAttachment ? excelAttachment.fileName : ''
    };

    // Логируем email контент (всегда)
    // console.log('📧 EMAIL CONTENT:');
    // console.log('='.repeat(50));
    // console.log(`To: ${emailData.to_email}`);
    // console.log(`Subject: Новые ответы на тест - ${emailData.test_type}`);
    // console.log(`Participant: ${emailData.participant_name} (${emailData.participant_email}, ${emailData.participant_phone})`);
    // console.log(`Test Date: ${emailData.test_date} в ${emailData.test_time}`);
    // console.log(`Summary: ${emailData.summary}`);
    // // console.log(`Excel Attachment: ${excelAttachment ? 'Yes - ' + excelAttachment.fileName : 'No'}`);
    // console.log(`Excel Attachment: Disabled (temporarily)`);
    // console.log(`Detailed Results:`);
    // console.log(emailData.detailed_results);
    // console.log('='.repeat(50));

    // Пробуем отправить email через EmailJS
    try {
      // console.log('🚀 Attempting to send email via EmailJS...');
      // console.log('Service ID:', EMAILJS_SERVICE_ID);
      // console.log('Template ID:', EMAILJS_TEMPLATE_ID);
      // console.log('Public Key:', EMAILJS_PUBLIC_KEY);
      
      // Подготавливаем параметры для EmailJS
      let emailParams = { ...emailData };
      

      // SMTP сервисы обычно не поддерживают динамические вложения
      // Поэтому просто отмечаем, что Excel файл создан
      // Excel файл временно отключен
      // if (excelAttachment) {
      //   console.log('📎 Excel file created (not attached due to SMTP limitations):', excelAttachment.fileName);
      //   console.log('💡 Excel file is available for download in browser');
      // }
      
      const response = await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        emailParams,
        EMAILJS_PUBLIC_KEY
      );
      
      // console.log('✅ Email sent successfully via EmailJS:', response);
      
      return { 
        success: true, 
        message: 'Email sent successfully via EmailJS!',
        // excelCreated: excelAttachment ? true : false,
        // excelFileName: excelAttachment ? excelAttachment.fileName : null
        excelCreated: false, // Excel временно отключен
        excelFileName: null
      };
      
    } catch (emailError) {
      console.warn('⚠️ EmailJS failed, but data is logged above for manual processing');
      console.error('EmailJS Error:', emailError);
      
      // Возвращаем успех, так как данные залогированы
      return { 
        success: true, 
        message: 'EmailJS failed, but data is logged for manual processing',
        // excelCreated: excelAttachment ? true : false,
        // excelFileName: excelAttachment ? excelAttachment.fileName : null
        excelCreated: false, // Excel временно отключен
        excelFileName: null,
        warning: 'EmailJS authentication failed - check console for data'
      };
    }
    
  } catch (error) {
    console.error('❌ General error in sendTestResultsEmail:', error);
    return { success: false, error: error.message };
  }
};

const getTestTitle = (testType) => {
  const titles = {
    'belbin': 'Анкета по Белбину',
    'natural_intelligence': 'Тест по природным интеллектам',
    'intelligence_types': 'Анкета по типам интеллекта',
    'ors': 'Тест на определение ОРС',
    'subtype': 'Тест на подтип личности'
  };
  return titles[testType] || 'Психологический тест';
};

const formatRawAnswersForEmail = (answers, testType) => {
  let formatted = '📋 ОТВЕТЫ НА ВОПРОСЫ ТЕСТА:\n\n';
  
  // Sort answers by question number
  const sortedAnswers = Object.entries(answers).sort(([a], [b]) => {
    const aNum = parseInt(a);
    const bNum = parseInt(b);
    return aNum - bNum;
  });
  
  sortedAnswers.forEach(([questionId, answer]) => {
    const questionNumber = parseInt(questionId);
    
    if (testType === 'belbin') {
      // For Belbin, answers are objects with role scores
      formatted += `Вопрос ${questionNumber}:\n`;
      Object.entries(answer).forEach(([role, score]) => {
        formatted += `  ${role.toUpperCase()}: ${score} баллов\n`;
      });
      formatted += '\n';
    } else {
      // For other tests, answers are simple values
      let answerText = answer;
      if (typeof answer === 'boolean') {
        answerText = answer ? 'Да' : 'Нет';
      } else if (typeof answer === 'string') {
        answerText = answer.toUpperCase();
      }
      formatted += `Вопрос ${questionNumber}: ${answerText}\n`;
    }
  });
  
  formatted += '\n📊 СТАТИСТИКА:\n';
  formatted += `Всего вопросов: ${sortedAnswers.length}\n`;
  
  if (testType === 'belbin') {
    const totalPoints = sortedAnswers.reduce((sum, [, answer]) => {
      return sum + Object.values(answer).reduce((a, b) => a + b, 0);
    }, 0);
    formatted += `Общее количество баллов: ${totalPoints}\n`;
  } else {
    const yesAnswers = sortedAnswers.filter(([, answer]) => answer === true || answer === 'a').length;
    const noAnswers = sortedAnswers.filter(([, answer]) => answer === false || answer === 'b').length;
    const otherAnswers = sortedAnswers.length - yesAnswers - noAnswers;
    formatted += `Ответов "Да": ${yesAnswers}\n`;
    formatted += `Ответов "Нет": ${noAnswers}\n`;
    if (otherAnswers > 0) {
      formatted += `Других ответов: ${otherAnswers}\n`;
    }
  }
  
  return formatted;
};

// Форматирование детальных результатов для email шаблона
export const formatDetailedResultsForEmail = (testResult, testType) => {
  const { allCategories, answers } = testResult;
  
  let result = '';
  
  if (testType === 'natural_intelligence') {
    result += 'ТИПЫ НАТУРЫ:\n';
    result += '='.repeat(40) + '\n';
    Object.entries(allCategories).forEach(([category, data]) => {
      result += `${category}: ${data.score} баллов (${data.percentage}%)\n`;
    });
  } else if (testType === 'intelligence_types') {
    result += 'ТИПЫ ИНТЕЛЛЕКТА:\n';
    result += '='.repeat(40) + '\n';
    Object.entries(allCategories).forEach(([category, data]) => {
      result += `${category}: ${data.score} баллов (${data.percentage}%)\n`;
    });
  } else if (testType === 'belbin') {
    result += 'КОМАНДНЫЕ РОЛИ БЕЛБИНА:\n';
    result += '='.repeat(40) + '\n';
    Object.entries(testResult.allRoles).forEach(([role, score]) => {
      result += `${role}: ${score} баллов\n`;
    });
    
    result += '\nДЕТАЛЬНЫЕ ОТВЕТЫ ПО БЛОКАМ:\n';
    result += '='.repeat(40) + '\n';
    
    // Добавляем детальные ответы по блокам
    const blockTitles = {
      1: "Какой вклад я могу внести в работу команды:",
      2: "Если у меня есть недостатки в командной работе, то возможно это потому, что:",
      3: "Когда я вовлечен в работу с другими:",
      4: "Особенности моего стиля работы в команде:",
      5: "Я получаю удовлетворение от работы, потому что:",
      6: "Если мне неожиданно предложат решить трудную задачу за ограниченное время с незнакомыми людьми, то:",
      7: "Проблемы, с которыми я сталкиваюсь, работая в команде:",
      8: "Когда я работаю с другими над проектом:"
    };
    
    for (let blockNum = 1; blockNum <= 8; blockNum++) {
      const blockAnswers = testResult.answers[blockNum];
      if (blockAnswers) {
        result += `\nБЛОК ${blockNum}. ${blockTitles[blockNum]}\n`;
        result += '-'.repeat(60) + '\n';
        
        const options = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h'];
        options.forEach(option => {
          const score = blockAnswers[option] || 0;
          result += `${option.toUpperCase()}) ${score} баллов\n`;
        });
        
        const totalScore = Object.values(blockAnswers).reduce((sum, val) => sum + (val || 0), 0);
        result += `Итого: ${totalScore} баллов\n`;
      }
    }
  } else if (testType === 'ors') {
    result += 'ДЕТАЛЬНЫЕ ОТВЕТЫ ПО ВОПРОСАМ:\n';
    result += '='.repeat(40) + '\n';
    
    // Добавляем детальные ответы по вопросам
    const questionTitles = {
      1: "Скорость",
      2: "Плохая погода", 
      3: "Красота",
      4: "Сила",
      5: "Новое платье",
      6: "Встреча с другом",
      7: "Воспоминания",
      8: "Проблемы",
      9: "Счастье",
      10: "Любовь",
      11: "Радость",
      12: "Спор",
      13: "Свобода",
      14: "Покупка",
      15: "Церковь",
      16: "Потребность какого из центров является для вас наиболее актуальной в жизни",
      17: "Какая из базовых эмоциональных реакций является для вас наиболее привычной",
      18: "Если все ваше время и энергию взять за 100%, то",
      19: "Что для вас является самым серьезным жизненным стрессом"
    };
    
    for (let questionNum = 1; questionNum <= 19; questionNum++) {
      const answer = testResult.answers[questionNum];
      if (answer !== undefined) {
        // Преобразуем числовой ответ в буквенный (0=A, 1=B, 2=C, 3=D)
        const answerLetter = String.fromCharCode(65 + parseInt(answer));
        result += `Вопрос ${questionNum}. ${questionTitles[questionNum]}: ${answerLetter}\n`;
      }
    }
  } else if (testType === 'subtype') {
    result += 'ДЕТАЛЬНЫЕ ОТВЕТЫ ПО ВОПРОСАМ:\n';
    result += '='.repeat(40) + '\n';
    
    // Добавляем детальные ответы по вопросам
    const questionTitles = {
      1: "Для меня важно",
      2: "Для меня важно",
      3: "Для меня ценны",
      4: "Меня более всего заботят",
      5: "На вечеринке я стараюсь общаться",
      6: "Меня больше всего раздражают люди, которые",
      7: "Я больше всего забочусь",
      8: "Мне лучше всего помогает снять стресс",
      9: "Я очень дорожу отношениями со своей",
      10: "Лучший спутник жизни для меня тот",
      11: "Считают, что у меня есть такое качество, как",
      12: "Я предпочитаю отдыхать",
      13: "Когда со мной начинают назойливо общаться не интересные для меня люди, я",
      14: "Я чаще использую для достижения цели",
      15: "В моей деятельности больше продуктивности, когда работаю",
      16: "Мне было бы особенно трудно пожертвовать",
      17: "Я чаще всего выбираю одежду",
      18: "Я предпочитаю читать",
      19: "Мои друзья особенно ценят во мне",
      20: "Когда я захожу в помещение, полное людей, я обычно обращаю внимание на",
      21: "Иногда в моем поведении слишком много",
      22: "Для меня важна",
      23: "Я предпочитаю проводить выходные",
      24: "Я больше фокусирую внимание",
      25: "Мне дискомфортно",
      26: "Друзья считают, что во мне преобладает",
      27: "В моих представлениях идеальный дом",
      28: "В моих представлениях идеальный автомобиль",
      29: "У меня есть склонность",
      30: "Мне нравится"
    };
    
    for (let questionNum = 1; questionNum <= 30; questionNum++) {
      const answer = testResult.answers[questionNum];
      if (answer !== undefined) {
        // Преобразуем числовой ответ в буквенный (0=A, 1=B, 2=C)
        const answerLetter = String.fromCharCode(65 + parseInt(answer));
        result += `Вопрос ${questionNum}. ${questionTitles[questionNum]}: ${answerLetter}\n`;
      }
    }
  }
  
  return result;
};

// Создание текстовой таблицы для email (как Excel)
export const createExcelLikeTable = (testResult, testType) => {
  const { allCategories, answers } = testResult;
  
  let tableText = '';
  
  if (testType === 'natural_intelligence') {
    tableText = '📊 ТИПЫ НАТУРЫ (Результаты)\n';
    tableText += '='.repeat(60) + '\n';
    tableText += 'Типы натуры'.padEnd(40) + 'Общая сумма'.padEnd(15) + 'С коэффициентом\n';
    tableText += '-'.repeat(60) + '\n';

    const categories = [
      { name: "Защитный характер" },
      { name: "Воспитательный характер" },
      { name: "Административный характер" },
      { name: "Творческая натура" },
      { name: "Исцеляющая (целебная) природа" },
      { name: "Развлекательный характер" },
      { name: "Обеспечивающая Природа" },
      { name: "Предпринимательский характер" },
      { name: "Авантюрная натура" }
    ];

    categories.forEach((category) => {
      const data = allCategories[category.name];
      const score = data ? data.score.toFixed(5) : '0.00000';
      const coefficient = data ? data.coefficient_score.toFixed(5) : '0.00000';
      tableText += category.name.padEnd(40) + score.padEnd(15) + coefficient + '\n';
    });

  } else if (testType === 'intelligence_types') {
    tableText = '📊 ТИПЫ ИНТЕЛЛЕКТА (Результаты)\n';
    tableText += '='.repeat(60) + '\n';
    tableText += 'Типы интеллекта'.padEnd(40) + 'Общая сумма'.padEnd(15) + 'С коэффициентом\n';
    tableText += '-'.repeat(60) + '\n';

    const categories = [
      { name: "Лингвистический" },
      { name: "Математико-логический" },
      { name: "Визуально-пространственный" },
      { name: "Музыкальный" },
      { name: "Межличностный" },
      { name: "Внутриличностный" },
      { name: "Грубый телесный" },
      { name: "Прекрасный телесный" },
      { name: "Визуально-графический" },
      { name: "Натуралистический (природный)" }
    ];

    categories.forEach((category) => {
      const data = allCategories[category.name];
      const score = data ? data.score.toFixed(5) : '0.00000';
      const coefficient = data ? data.coefficient_score.toFixed(5) : '0.00000';
      tableText += category.name.padEnd(40) + score.padEnd(15) + coefficient + '\n';
    });
  } else if (testType === 'belbin') {
    tableText = '📊 КОМАНДНЫЕ РОЛИ БЕЛБИНА (Результаты)\n';
    tableText += '='.repeat(60) + '\n';
    tableText += 'Командные роли'.padEnd(40) + 'Баллы\n';
    tableText += '-'.repeat(60) + '\n';

    const roles = [
      { name: "Исполнитель" },
      { name: "Координатор" },
      { name: "Формирователь" },
      { name: "Генератор идей" },
      { name: "Исследователь ресурсов" },
      { name: "Оценщик" },
      { name: "Коллективист" },
      { name: "Доводчик" }
    ];

    roles.forEach((role) => {
      const score = testResult.allRoles[role.name] || 0;
      tableText += role.name.padEnd(40) + score.toString() + '\n';
    });
  } else if (testType === 'ors') {
    // Для теста ORS не создаем таблицу Excel, только детальные ответы
    tableText = '';
  } else if (testType === 'subtype') {
    tableText = '📊 ИТОГОВЫЕ ЦИФРЫ (Результаты)\n';
    tableText += '='.repeat(60) + '\n';
    tableText += 'Сумма набранных баллов\n';
    tableText += '-'.repeat(60) + '\n';
    
    // Подсчитываем баллы по категориям a, b, c
    let aScore = 0, bScore = 0, cScore = 0;
    
    for (let questionNum = 1; questionNum <= 30; questionNum++) {
      const answer = testResult.answers[questionNum];
      if (answer !== undefined) {
        if (answer === 0) aScore++;
        else if (answer === 1) bScore++;
        else if (answer === 2) cScore++;
      }
    }
    
    tableText += 'a)'.padEnd(40) + aScore.toString() + '\n';
    tableText += 'b)'.padEnd(40) + bScore.toString() + '\n';
    tableText += 'c)'.padEnd(40) + cScore.toString() + '\n';
  }
  
  return tableText;
};

// Keep the old function for backward compatibility but mark as deprecated
export const generateChartImage = async (chartData, testType) => {
  console.warn('generateChartImage is deprecated - charts are no longer generated');
  return null;
};
